import { http } from "./config";
import authHeader from "./auth-header";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

export default {
  // Listar todas as conversas do usuário autenticado
  listarConversas: () => {
    return http.get("/api/chat/conversas", {
      headers: authHeader(),
    });
  },

  obterTotalMensagensNaoLidas: () => {
    return http.get("/api/chat/conversas/nao-lidas/total", {
      headers: authHeader(),
    });
  },

  // Criar uma nova conversa de grupo
  criarConversaGrupo: (nome, participantes) => {
    return http.post(
      `/api/chat/conversas/grupo`,
      {
        nome: nome,
        participantes: participantes,
      },
      {
        headers: authHeader(),
      },
    );
  },

  // Obter histórico de mensagens de uma conversa
  isChatMessagePayload: (payload) => {
    return !!(
      payload &&
      payload.id &&
      payload.idConversa &&
      payload.idRemetente !== undefined &&
      payload.tipo
    );
  },

  isChatConversationPayload: (payload) => {
    return !!(
      payload &&
      payload.id &&
      payload.tipo &&
      payload.nomeChat &&
      payload.dataCriacao
    );
  },

  // Encaminhar mensagens: uma conversa 1:1 por destinatário (não cria grupo)
  encaminharMensagens: (idsMensagens, idsDestinatarios) => {
    return http.post(
      `/api/chat/mensagens/encaminhar`,
      { idsMensagens, idsDestinatarios },
      { headers: authHeader() },
    );
  },

  // Excluir ("apagar para todos") uma mensagem do próprio usuário
  excluirMensagem: (idMensagem) => {
    return http.delete(`/api/chat/mensagens/${idMensagem}`, {
      headers: authHeader(),
    });
  },

  iniciarConversaPrivada: (idParticipante, conteudo) => {
    return http.post(
      `/api/chat/conversas/privada/iniciar`,
      {
        idParticipante,
        conteudo,
      },
      {
        headers: authHeader(),
      },
    );
  },

  obterMensagens: (idConversa, params = {}) => {
    return http.get(`/api/chat/conversas/${idConversa}/mensagens`, {
      headers: authHeader(),
      params,
    });
  },

  marcarConversaComoLida: (idConversa, ateMensagemId) => {
    return http.put(
      `/api/chat/conversas/${idConversa}/leitura`,
      { ateMensagemId },
      { headers: authHeader() },
    );
  },

  // Obter dados de uma conversa específica
  obterConversa: (idConversa) => {
    return http.get(`/api/chat/conversas/${idConversa}`, {
      headers: authHeader(),
    });
  },

  // Listar participantes de um grupo
  listarParticipantes: (idConversa) => {
    return http.get(`/api/chat/conversas/${idConversa}/participantes`, {
      headers: authHeader(),
    });
  },

  // Adicionar participante ao grupo
  adicionarParticipante: (idConversa, idParticipante) => {
    return http.post(
      `/api/chat/conversas/${idConversa}/participantes/${idParticipante}`,
      {},
      { headers: authHeader() },
    );
  },

  // Remover participante do grupo
  removerParticipante: (idConversa, idParticipante) => {
    return http.delete(
      `/api/chat/conversas/${idConversa}/participantes/${idParticipante}`,
      { headers: authHeader() },
    );
  },

  // Sair do grupo
  sairDoGrupo: (idConversa) => {
    return http.post(
      `/api/chat/conversas/${idConversa}/sair`,
      {},
      { headers: authHeader() },
    );
  },

  // Transferir propriedade do grupo
  transferirPropriedade: (idConversa, idNovoProprietario) => {
    return http.post(
      `/api/chat/conversas/${idConversa}/transferir-propriedade/${idNovoProprietario}`,
      {},
      { headers: authHeader() },
    );
  },

  // Promover participante a administrador
  promoverAdmin: (idConversa, idParticipante) => {
    return http.post(
      `/api/chat/conversas/${idConversa}/promover-admin/${idParticipante}`,
      {},
      { headers: authHeader() },
    );
  },

  // Rebaixar administrador para participante comum
  rebaixarAdmin: (idConversa, idParticipante) => {
    return http.post(
      `/api/chat/conversas/${idConversa}/rebaixar-admin/${idParticipante}`,
      {},
      { headers: authHeader() },
    );
  },

  // Editar nome do grupo
  editarNomeGrupo: (idConversa, novoNome) => {
    return http.post(
      `/api/chat/conversas/${idConversa}/editar-nome`,
      { nome: novoNome },
      { headers: authHeader() },
    );
  },

  // Favoritar uma conversa
  favoritarConversa: (idConversa) => {
    return http.post(
      `/api/chat/conversas/${idConversa}/favoritar`,
      {},
      { headers: authHeader() },
    );
  },

  // Remover favorito de uma conversa
  removerFavoritoConversa: (idConversa) => {
    return http.delete(
      `/api/chat/conversas/${idConversa}/favoritar`,
      { headers: authHeader() },
    );
  },

  // Status
  consultarStatus() {
    return http.get("/api/chat/status", {
      headers: authHeader(),
    });
  },

  obterConfiguracao() {
    return http.get("/api/chat/configuracao", {
      headers: authHeader(),
    });
  },

  salvarConfiguracao(configuracao) {
    return http.put("/api/chat/configuracao", configuracao, {
      headers: authHeader(),
    });
  },

  // WebSocket connection with authentication
  connectWebSocket: (callbacks) => {
    // garante que não tenha barra dupla
    const wsUrl = `${http.defaults.baseURL.replace(/\/$/, "")}/ws`;

    const socket = new SockJS(wsUrl);
    const stompClient = Stomp.over(socket);
    stompClient.debug = () => {};

    stompClient.connect(
      authHeader(),
      (frame) => {
        if (callbacks && callbacks.onConnect) {
          callbacks.onConnect(frame, stompClient);
        }
      },
      (error) => {
        if (callbacks && callbacks.onError) {
          callbacks.onError(error);
        }
      },
    );

    return stompClient;
  },

  // Disconnect WebSocket
  disconnectWebSocket: (stompClient) => {
    if (stompClient && stompClient.connected) {
      stompClient.disconnect();
      return true;
    }
    return false;
  },

  // Subscribe to conversation topic
  subscribeToUser: (stompClient, callback, readCallback, statusCallback) => {
    if (!stompClient || !stompClient.connected)
      return {
        messageSubscription: null,
        readSubscription: null,
        statusSubscription: null,
      };

    const userId = JSON.parse(sessionStorage.getItem("user")).id;

    // Inscrição para receber mensagens
    const messageSubscription = stompClient.subscribe(
      `/topic/usuario.${userId}`,
      (message) => {
        if (callback) {
          callback(JSON.parse(message.body));
        }
      },
    );

    // Inscrição para receber notificações de leitura
    const readSubscription = stompClient.subscribe(
      `/topic/usuario.${userId}/leitura`,
      (message) => {
        if (readCallback) {
          readCallback(JSON.parse(message.body));
        }
      },
    );

    // Inscrição para receber notificações de status/presença
    const statusSubscription = stompClient.subscribe(
      `/topic/usuario.${userId}/presenca`,
      (message) => {
        if (statusCallback) {
          statusCallback(JSON.parse(message.body));
        }
      },
    );

    return { messageSubscription, readSubscription, statusSubscription };
  },

  // Send message via WebSocket
  sendMessageViaWebSocket: (
    stompClient,
    conversationId,
    userId,
    content,
    type = "TEXTO",
    replyToId = null,
  ) => {
    if (!stompClient || !stompClient.connected) {
      console.error("Tentativa de enviar mensagem sem conexão WebSocket ativa");
      return false;
    }

    try {
      const messageData = {
        idConversa: conversationId,
        idRemetente: userId,
        conteudo: content,
        tipo: type,
      };
      if (replyToId) {
        messageData.replyToId = replyToId;
      }

      stompClient.send("/app/chat.enviar", JSON.stringify(messageData), {});

      return true;
    } catch (error) {
      console.error("Erro ao enviar mensagem via WebSocket:", error);
      return false;
    }
  },

  // Atualizar status do usuário via WebSocket
  updateUserStatusViaWebSocket: (stompClient, status) => {
    if (!stompClient || (!stompClient.connected && !stompClient.active)) {
      console.error("WebSocket não conectado");
      return false;
    }

    const validStatuses = [
      "ONLINE",
      "AUSENTE",
      "OCUPADO",
      "NAO_PERTURBE",
      "OFFLINE",
    ];
    if (!validStatuses.includes(status)) {
      console.error("Status inválido:", status);
      return false;
    }

    try {
      stompClient.send("/app/chat.status", JSON.stringify({ status }), {});

      return true;
    } catch (error) {
      console.error("Erro ao enviar status:", error);
      return false;
    }
  },

  // Enviar ping para manter a conexão WebSocket ativa
  sendPing: (stompClient) => {
    if (!stompClient || (!stompClient.connected && !stompClient.active)) {
      console.error("WebSocket não conectado, não foi possível enviar ping");
      return false;
    }

    try {
      stompClient.send("/app/chat.ping", JSON.stringify({}), {});
      return true;
    } catch (error) {
      console.error("Erro ao enviar ping:", error);
      return false;
    }
  },

  // Enviar arquivo em uma conversa
  enviarArquivo: (idConversa, arquivo) => {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    
    return http.post(`/api/chat/conversas/${idConversa}/arquivo`, formData, {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Obter lista de arquivos de uma conversa
  listarArquivos: (idConversa) => {
    return http.get(`/api/chat/conversas/${idConversa}/arquivos`, {
      headers: authHeader()
    });
  },
};
